import { EInsideTAInfrastructureType, EOutsideTAInfrastructureType, ITAInfrastructure } from '../../types/map';

export const mkTransportAccessibilityInfrastructure = (): ITAInfrastructure => ({
  outside: {
    busStops: [
      {
        id: 'itd:1',
        title: 'Ленинский проспект 45',
        timeWalk: 34,
        coordinates: {
          lat: 55.57844,
          lng: 37.483653,
        },
        routes: ['432', '123у'],
        type: EOutsideTAInfrastructureType.busStops,
      },
    ],
    tramStops: [
      {
        id: 'itd:2',
        title: 'Ленинский проспект 45',
        timeWalk: 34,
        coordinates: {
          lat: 55.581346,
          lng: 37.478552,
        },
        routes: ['4'],
        type: EOutsideTAInfrastructureType.tramStops,
      },
    ],
    metro: [
      {
        id: 'itd:3',
        title: 'Ленинский проспект 45',
        coordinates: {
          lat: 55.581466,
          lng: 37.474169,
        },
        timeWalk: 34,
        line: {
          color: '#FF0000',
        },
        type: EOutsideTAInfrastructureType.metro,
      },
    ],
    parking: [
      {
        id: 'itd:4',
        title: 'Парковка',
        coordinates: {
          lat: 55.5688942,
          lng: 37.4653532,
        },
        capacity: 12,
        description: 'Для инвалидов',
        type: EOutsideTAInfrastructureType.parking,
      },
    ],
    bikeParking: [
      {
        id: 'itd:5',
        title: 'Велопарковка',
        coordinates: {
          lat: 55.5688942,
          lng: 37.4653532,
        },
        type: EOutsideTAInfrastructureType.bikeParking,
      },
    ],
    scooterParking: [],
    chargingStations: [
      {
        id: 'itd:6',
        title: 'Станция зарядки электромобилей',
        coordinates: {
          lat: 55.5688942,
          lng: 37.4653532,
        },
        type: EOutsideTAInfrastructureType.chargingStations,
      },
    ],
    boulevards: [],
  },
  inside: {
    yardWithoutCars: [
      {
        id: 'itd:7',
        title: 'Двор без машин',
        description: 'Территория для пешеходов',
        coordinates: {
          lat: 55.5688942,
          lng: 37.4653532,
        },
        type: EInsideTAInfrastructureType.yardWithoutCars,
      },
    ],
    parking: [
      {
        id: 'itd:8',
        title: 'Парковка',
        coordinates: {
          lat: 55.5689944,
          lng: 37.4653532,
        },
        capacity: 12,
        type: EInsideTAInfrastructureType.parking,
      },
    ],
    placeOfShortTransportStop: [],
    bikeParking: [],
    chargingStations: [],
    scooterParking: [],
    boulevards: [],
    trafficSafetyElements: [],
  },
});
